module.exports = __webpack_public_path__ + "static/img/yddpos.de7cbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/yddpos.png
// module id = NKLb
// module chunks = 1